import { render, staticRenderFns } from "./akcd_overview.vue?vue&type=template&id=f143e1d8&scoped=true"
import script from "./akcd_overview.vue?vue&type=script&lang=js"
export * from "./akcd_overview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f143e1d8",
  null
  
)

export default component.exports